import './styles/style.css'
import ReactDOM from 'react-dom/client'
// import { Stats } from '@react-three/drei'
import { KeyboardControls } from '@react-three/drei'
import Interface from './Interface/Interface.jsx'
const root = ReactDOM.createRoot(document.querySelector('#root'));
import { ModalProvider } from './contexts/ModalContext.jsx'
import { ThemeProvider } from './contexts/ThemeContext.jsx'
import { DimensionalProvider } from './contexts/DimensionalContext.jsx'
import DimensionSwitch from './DimensionSwitch.jsx'
import Interface2D from './components2D/Interface2D.jsx';
import { Modal2DProvider } from './contexts/Modal2DContext.jsx';

root.render(
    // Names For all key identifiers(DON'T CHANGE unless you want to replace every instance of that key name)
    <DimensionalProvider>
    <ThemeProvider>
    <ModalProvider>
    <Modal2DProvider>
        <KeyboardControls
                map={[
                    { name: 'forward', keys: ['ArrowUp', "KeyW"]},
                    { name: 'backward', keys: ['ArrowDown', "KeyS"]},
                    { name: 'leftward', keys: ['ArrowLeft', "KeyA"]},
                    { name: 'rightward', keys: ['ArrowRight', "KeyD"]},
                    { name: 'jump', keys: ['Space']},
                    { name: 'run', keys: ['Shift']}
                ]}
            >
                {/* 
                    DimensionSwitch for 
                    2D and 3D Portfolio
                    Experiences
                */}
                <DimensionSwitch />
                <Interface /> 
                <Interface2D />
            </KeyboardControls>
    </Modal2DProvider>
    </ModalProvider>
    </ThemeProvider>
    </DimensionalProvider>
)